import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=0972fc8d&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"
import style1 from "./Contact.vue?vue&type=style&index=1&id=0972fc8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0972fc8d",
  null
  
)

export default component.exports